<template>
  <create-location />
</template>

<script>
import CreateLocation from "@/components/3pl/Settings/LocationAndTax/Location/NewLocation";
export default {
  components: {
    CreateLocation,
  },
};
</script>

<style></style>
